import { Outlet } from 'react-router-dom'
import { Toaster } from 'sonner'

const Layout = () => {
  return (<>
    <Outlet />
    <Toaster 
      position='top-center'
      toastOptions={{
        className: '',
        style: {
          marginTop: window.innerHeight / 2,
          background: 'rgba(0, 0, 0, 0.7)',
          fontSize: '12px',
          padding: '12px 14px',
          color: '#FFFFFF',
          border: 'none',
          textAlign: 'center',
          justifyContent: 'center',
        },
        duration: 1500,
      }}
    />
  </>)
}

export default Layout 